'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { InternalNetworkExecutionSelectDialog } from './InternalNetworkExecutionSelectDialog';
import {
  EDR_ASSESSMENT_MODE_VALUES,
  isInternalNetworkEdrAssessmentMode,
  type InternalNetworkEdrAssessmentMode,
} from './internal-execution.model';

export type InternalNetworkEdrAssessmentModeDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  edrAssessmentMode: InternalNetworkEdrAssessmentMode;
  isDiscoveryActive: boolean;
  isUpdating: boolean;
  onSubmit: (mode: InternalNetworkEdrAssessmentMode) => Promise<boolean>;
};

export function InternalNetworkEdrAssessmentModeDialog({
  open,
  onOpenChange,
  edrAssessmentMode,
  isDiscoveryActive,
  isUpdating,
  onSubmit,
}: InternalNetworkEdrAssessmentModeDialogProps) {
  const t = useTranslations('designSystem.networkSettings.internalExecution');
  const items = useMemo(
    () =>
      EDR_ASSESSMENT_MODE_VALUES.map((mode) => ({
        label: t(`edrAssessmentModeValues.${mode}`),
        value: mode,
      })),
    [t],
  );

  return (
    <InternalNetworkExecutionSelectDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('editEdrAssessmentModeTitle')}
      label={t('edrAssessmentMode')}
      helperText={t('edrAssessmentModeHelper')}
      value={edrAssessmentMode}
      items={items}
      isValue={isInternalNetworkEdrAssessmentMode}
      isSubmitBlocked={isDiscoveryActive}
      isUpdating={isUpdating}
      onSubmit={onSubmit}
    />
  );
}
